<template>
  <div id="confirm" class="payment-wrapper">
  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    name: 'Subscription',
    data () {
      return {
      }
    },
    updated () {

     
      localStorage.removeItem('jwt')
      var confirmCode = this.$route.query.code
      console.log(confirmCode)
    },
    mounted () {
      
      var jwttoken = localStorage.getItem('jwt')
      var confirmCode = this.$route.query.code
      
      var uid = localStorage.getItem('uid')
      axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/addBankAccount',
        {
          code: confirmCode,
          uid: uid
        }, {
          headers: {
            'x-access-token': jwttoken
          }})
        .then(response => {
          console.log(jwttoken)
          if(jwttoken !== '' && jwttoken !== null)
            {
              
             localStorage.setItem('jwt', jwttoken)
             this.$router.push('userprofile')
            }else{
              
              localStorage.removeItem('jwt')
              this.$router.push('login')
            } 
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    }
  
}
</script>







// WEBPACK FOOTER //
// src/components/Confirm.vue